import { useNavigate } from "react-router-dom";
import club_logo from '../images/riverrun.png'
import { useContext, useState } from "react";
import { base_url } from '../url_variables';
import axios from 'axios';
import { GridLoader } from "react-spinners";
import { useCookies } from "react-cookie";
import { TostMessageContext } from "../context/TostMessage";

export default function CreateAccount() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formFields, setFormFields] = useState({});
  const [cookies, setCookie, removeCookie] = useCookies();
  const [userProfile, setUserProfile] = useState({});
  const [errMsg, setErrMsg] = useState(null);
  const { setTostMessage } = useContext(TostMessageContext);

  const handleLogin = async () => {
    setLoading(true);
    const formData = new FormData();
    Object.entries(formFields).forEach(([key, value]) => {
        formData.append(key, value);
    });

    const date = new Date();
    let expiresDate = date.setTime(date.getTime() + 24 * 60 * 60 * 1000); // 24 hours

    try {
        const response = await axios.post(base_url + '/register.php', formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        if (response.data.status) {
            setTostMessage({
                messageType: "success",
                message: response.data.message,
            });
            setLoading(false);
            setCookie("userProfile", response.data.user, {
                path: "/",
                maxAge: expiresDate,
                secure: true,
            });
            setUserProfile(response.data.user);
            navigate("/dashboard/home");
        } else {
            setLoading(false);
            setErrMsg(response.data.response);
        }
    } catch (error) {
        setLoading(false);
        setErrMsg('Network error');
    }
  };

  return (
    <div className="flex flex-col gap-y-5 items-center justify-center min-h-screen bg-gray-50">
      <div className="bg-white p-6 rounded-lg shadow-md w-96 space-y-6">
        <div className='flex flex-col justify-start items-center w-full mt-[10px] mb-[10px]'>
            <img src={club_logo} className="h-[80px] mr-2" alt="logo" />
            <h2 className="text-center text-lg font-semibold mt-3">Create a New Account</h2>
        </div>
        {errMsg != null && <div className="border border-1 border-[#ff0000] mb-[10px] bg-[#ffdede] py-2 rounded-[5px] flex items-center justify-center">
            <p className="text-[#d40000]">{errMsg}</p>
        </div>}
        <input onChange={(e) => setFormFields({...formFields, first_name: e.target.value})} className="w-full border p-2 rounded" placeholder="First Name" />
        <input onChange={(e) => setFormFields({...formFields, last_name: e.target.value})} className="w-full border p-2 rounded" placeholder="Last Name" />
        <input onChange={(e) => setFormFields({...formFields, email: e.target.value})} className="w-full border p-2 rounded" placeholder="Email Address" />
        <input onChange={(e) => setFormFields({...formFields, password: e.target.value})} className="w-full border p-2 rounded" type="password" placeholder="Password" />
        <button 
          className="bg-primary h-[40px] flex items-center justify-center text-white w-full rounded hover:bg-secondary"
          onClick={handleLogin}
        >
          {loading ? (
                <GridLoader
                    color={'#ffffff'}
                    loading={loading}
                    size={5}
                    aria-label="Loading Spinner"
                    data-testid="loader"
                />
                ) : 'Create Account'
            }
        </button>
        <div className="flex flex-row mx-auto items-center justify-center">
          <a>Already have an account yet?</a><p onClick={() => navigate('/')} className="cursor-pointer ml-2 text-primary font-semibold font-aileron-regular">Login</p>
        </div>
        <div className="flex flex-row mx-auto items-center justify-center">
          <a className="cursor-pointer ml-2 text-sm text-secondary font-regular font-aileron-regular">Terms & Conditions</a>
          <a className="cursor-pointer ml-2 text-sm text-secondary font-regular font-aileron-regular">Privacy policy</a>
        </div>
      </div>
      <a href="https://riverrunresidence.com" className="underline text-sm font-aileron-regular cursor-pointer">Back to riverrunresidence.com</a>
    </div>
  );
}
